exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-container{\r\n  margin-top: 35px;\r\n}\r\n\r\n.item-usage-button-right{\r\n  right: 0;\r\n  top: 0;\r\n  position: absolute;\r\n  margin: 10px 15px 10px 10px;\r\n}\r\n\r\n#error-message{\r\n  color: red;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Projects/ePlanner Maintenance/src/app/controllers/calendars/modal-item-order/modal-item-order.component.css
// module id = ../../../../../src/app/controllers/calendars/modal-item-order/modal-item-order.component.css
// module chunks = main